// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/dashboard/default';
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

// Browser-facing api-gateway URL, baked in at build time (this is a pure
// client-rendered SPA - every request comes from the browser).
export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080/v1';

const config = {
  fontFamily: `'Public Sans', sans-serif`
};

export default config;
